"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.smpExamens = exports.smpExamen = exports.smpExamenBilans = exports.smpExamenBilan = exports.ssoExamens = exports.ssoExamen = exports.ssoExamenBilans = exports.ssoExamenBilan = exports.ssoContextActionSyntheses = exports.ssoContextActionSynthese = exports.ssoContextContactMads = exports.ssoContextContactMad = exports.ssoContextPersonnesSurPlaces = exports.ssoContextPersonneSurPlace = exports.ssoContext = exports.ssoNumeroIntervention = exports.ssoAdresseIntervention = exports.ssoSmp = void 0;
const utils_1 = require("../utils");
const utils = __importStar(require("../utils"));
const data_1 = require("../data");
exports.ssoSmp = [
    {
        '@type': 'text',
        key: '48fe3459-3de7-44d0-9eef-854f5aacc46c',
        label: 'Événement concerné',
        value: bilan => bilan.sso_smp.evenement_concerne,
    },
    {
        '@type': 'text',
        key: 'f56e9b47-761a-459a-8e8f-00d1f2059d6d',
        label: 'Personnels impactés',
        value: bilan => bilan.sso_smp.personnels_impactes,
    },
    {
        '@type': 'text',
        key: '54ded073-c5de-4ef9-8ce9-3e93c4fb5489',
        label: 'Première réactions équipes',
        value: bilan => bilan.sso_smp.premier_reactions_equipes,
    },
    {
        '@type': 'text',
        key: '2bede88d-6e74-42f8-ba42-130f65745ec5',
        label: 'Solicitation SSSM',
        value: bilan => bilan.sso_smp.solicitation_sssm,
    },
    {
        '@type': 'text',
        key: '9b3ffc7b-b4f3-4d78-be95-a3335a025d3c',
        label: 'Organisation SMP',
        value: bilan => bilan.sso_smp.organisation_smp,
    },
    {
        '@type': 'text',
        key: '74b39733-2df3-4cbc-8bcc-74d8e7eab626',
        label: 'Réalisation SMP',
        value: bilan => bilan.sso_smp.realisation_smp,
    },
    {
        '@type': 'tristate',
        key: '946eefcc-3290-483b-b719-9032d56e0f5a',
        label: 'MAD prévenu',
        value: bilan => bilan.sso_smp.prevenu_mad,
    },
    {
        '@type': 'tristate',
        key: 'f8b80684-8d89-487d-b01e-e039a89a6ca9',
        label: 'Mesure collective terrain',
        value: bilan => bilan.sso_smp.mesure_collective_terrain,
    },
    {
        '@type': 'tristate',
        key: 'dcd951ba-95c1-4375-8819-8beba4835e5a',
        label: 'Présence encadrement caserne',
        value: bilan => bilan.sso_smp.presence_encadrement_caserne,
    },
    {
        '@type': 'dateTime',
        key: '39a2d28c-83e1-4030-8f65-091b4d3349ae',
        label: 'Heure de début SMP',
        value: bilan => {
            return {
                time: bilan.sso_smp.start_time,
                date: bilan.sso_smp.start_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '95411746-0526-4cc1-952f-4f8371b08524',
        label: 'Heure de fin SMP',
        value: bilan => {
            return {
                time: bilan.sso_smp.end_time,
                date: bilan.sso_smp.end_date,
            };
        },
    },
];
exports.ssoAdresseIntervention = [
    {
        '@type': 'text',
        key: '01ddb257-c2d2-4411-ace3-032348289d2a',
        label: 'Adresse intervention',
        value: bilan => bilan.sso_context.adresse_intervention,
    },
];
exports.ssoNumeroIntervention = [
    {
        '@type': 'text',
        key: 'b4b9e5cd-3223-443b-a3e5-056ad57a3aed',
        label: 'Numéro intervention',
        value: bilan => bilan.sso_context.numero_intervention,
    },
];
exports.ssoContext = [
    ...exports.ssoAdresseIntervention,
    ...exports.ssoNumeroIntervention,
    {
        '@type': 'text',
        key: 'beadc1b1-e326-4017-8413-c1c0c148b9a8',
        label: 'Type intervention',
        value: bilan => bilan.sso_context.type_intervention,
    },
    {
        '@type': 'text',
        key: 'aca8dee6-4e31-4e73-8138-3fa5cd188b86',
        label: 'Commandement',
        value: bilan => bilan.sso_context.commandement,
    },
    {
        '@type': 'text',
        key: 'c4394dd3-c8b2-4f5a-9873-c2afb1a1f7b4',
        label: 'Descriptif intervention',
        value: bilan => bilan.sso_context.descriptif_intervention,
    },
    {
        '@type': 'text',
        key: '500b106b-e26b-4b53-a2b7-7d1a9887f706',
        label: 'Particularité intervention',
        value: bilan => bilan.sso_context.particulariter_intervention,
    },
    {
        '@type': 'category',
        key: 'bf9df175-6242-4b72-886e-a3637fa86582',
        columns: 1,
        className: 'cardGridLarge',
        title: 'Horodatage',
        children: [
            {
                '@type': 'dateTime',
                key: 'b50aa4d2-8fce-45df-bbbf-66df992a0581',
                label: "Heure de début d'intervention",
                value: bilan => {
                    return {
                        time: bilan.sso_context.debut_time_intervention,
                        date: bilan.sso_context.debut_date_intervention,
                    };
                },
            },
            {
                '@type': 'dateTime',
                key: 'd8a496bd-60b4-4a98-a0e3-9c6dbfced270',
                label: "Heure d'engagement SSO",
                value: bilan => {
                    return {
                        time: bilan.sso_context.engagement_time_intervention,
                        date: bilan.sso_context.engagement_date_intervention,
                    };
                },
            },
            {
                '@type': 'dateTime',
                key: 'f9bfd33f-5667-40f0-ad61-1057ae983f11',
                label: 'Heure du premier contact COS',
                value: bilan => {
                    return {
                        time: bilan.sso_context.premier_contact_cos_time,
                        date: bilan.sso_context.premier_contact_cos_date,
                    };
                },
            },
            {
                '@type': 'dateTime',
                key: 'f25687f7-6678-4391-849b-f9782d68570c',
                label: 'Heure du désengagement COS',
                value: bilan => {
                    return {
                        time: bilan.sso_context.desengagement_cos_time,
                        date: bilan.sso_context.desengagement_cos_date,
                    };
                },
            },
        ],
    },
    {
        '@type': 'category',
        key: '324cc344-b32d-49f4-870d-f111c6de3d55',
        columns: 1,
        className: 'cardGridLarge',
        title: 'Prises en charges',
        children: [
            {
                '@type': 'integer',
                key: 'd07bb192-348a-4241-b8e4-e2e930831a73',
                label: 'Nombre de surveillance simple',
                value: bilan => bilan.sso_context.nbr_surveillance_simple,
            },
            {
                '@type': 'integer',
                key: 'b38c0620-13de-489e-84cf-308b13f97896',
                label: 'Nombre de soins',
                value: bilan => bilan.sso_context.nbr_soins,
            },
            {
                '@type': 'integer',
                key: '1b8e8e16-35ac-4ca4-b8e9-53d5915cfe01',
                label: "Nombre d'évacuation",
                value: bilan => bilan.sso_context.nbr_evacuation,
            },
            {
                '@type': 'integer',
                key: '5d4ccf08-053f-4af2-a894-fb24082715a7',
                label: "Nombre de SP au plus haut de l'intervention",
                value: bilan => bilan.sso_context.nbr_sp,
                unit: ' SP',
            },
        ],
    },
    {
        '@type': 'integer',
        key: 'da259b8d-2fc0-4d12-8c2e-9461fc293f54',
        label: 'Durée estimée',
        unit: ' heures',
        value: bilan => bilan.sso_context.duree_estimee,
    },
    {
        '@type': 'tristate',
        key: '5354c45d-2e18-4db4-a23d-eb9cb793fa3c',
        label: 'Longue durée',
        value: bilan => (0, utils_1.boolToChar)(bilan.sso_context.longue_duree),
    },
    {
        '@type': 'text',
        key: 'e28c2824-7a6f-43da-be79-9758287d1c51',
        label: 'Personnel SSSM',
        value: bilan => bilan.sso_context.personnel_sssm,
    },
    {
        '@type': 'text',
        key: '14104fd7-5549-4d98-a2c9-b475539f86a1',
        label: 'Moyen SSO',
        value: bilan => bilan.sso_context.moyen_sso,
    },
    {
        '@type': 'text',
        key: '993591b3-ccc7-4c87-ac8f-b43ae96aba68',
        label: 'Risque',
        value: bilan => bilan.sso_context.risque,
    },
    {
        '@type': 'text',
        key: '2b3cec70-2a8a-4b9e-bc0d-f8f47a42824e',
        label: 'Intoxication',
        value: bilan => bilan.sso_context.intoxication,
    },
    {
        '@type': 'tristate',
        key: '7abc2583-e620-4747-9352-652c8e180565',
        label: 'Risque psychologique',
        value: bilan => bilan.sso_context.risque_psychologique,
    },
    {
        '@type': 'tristate',
        key: 'b020b45a-16c3-4c4f-a4da-240bbc66cc67',
        label: 'TCL avec MAD',
        value: bilan => bilan.sso_context.use_tcl_with_mad,
    },
    /**
     * TODO()
     * List<excel_contact_mad
     * List<excel_person_in_place
     * List<excel_action_synthese
     */
];
exports.ssoContextPersonneSurPlace = [
    {
        '@type': 'text',
        key: '894291a7-55fc-4b21-90e8-f099bb6ee23d',
        label: 'Nom',
        value: elem => elem.nom,
    },
    {
        '@type': 'text',
        key: 'c871769c-25f3-4ae0-937a-49e6eed7278b',
        label: 'Type',
        value: elem => elem.type,
    },
    {
        '@type': 'dateTime',
        key: '715f0fca-895e-4f13-97bc-adb923300d08',
        label: 'Arrivée',
        value: elem => {
            return {
                time: elem.time_start,
                date: elem.date_start,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '8f4d2c29-fc1f-4175-9299-ad8b674cd67b',
        label: 'Départ',
        value: elem => {
            return {
                time: elem.time_end,
                date: elem.date_end,
            };
        },
    },
];
exports.ssoContextPersonnesSurPlaces = [
    {
        '@type': 'table',
        key: '4716f58c-2178-45a0-83b7-9e4cef58e464',
        label: 'Personnes sur place',
        value: bilan => bilan.sso_context.excel_person_in_place || [],
        template: 'SSO_CONTEXT_PERSON_IN_PLACE',
    },
];
exports.ssoContextContactMad = [
    {
        '@type': 'dateTime',
        key: '9663c85b-b5e5-4fe7-8dd1-ea81ad9ad809',
        label: 'Date du contact',
        value: elem => {
            return {
                time: elem.time,
                date: elem.date,
            };
        },
    },
];
exports.ssoContextContactMads = [
    {
        '@type': 'table',
        key: 'f8b0e353-22cd-4ae8-a750-4eab765f3f30',
        label: 'Contact MAD',
        value: bilan => bilan.sso_context.excel_contact_mad || [],
        template: 'SSO_CONTEXT_CONTACT_MAD',
    },
];
exports.ssoContextActionSynthese = [
    {
        '@type': 'dateTime',
        key: '94e34af5-d15b-4dff-b68e-e02962b9f58e',
        label: 'Horaire',
        value: elem => {
            return {
                time: elem.time,
                date: elem.date,
            };
        },
    },
    {
        '@type': 'text',
        key: 'db67e9ea-9d16-430f-87e5-4ae03504775e',
        label: 'Mesure',
        value: elem => elem.mesure,
    },
    {
        '@type': 'tristate',
        key: '0253fd66-159c-4044-b2b2-5df96a14984d',
        label: 'Validation',
        // Suite demande SDIS 38: retourne uniquement 'oui' ou 'NR'
        value: elem => (elem.validation === false ? 'u' : 'y'),
    },
    {
        '@type': 'text',
        key: '683e7a26-a576-4dda-8afc-f4cc2c7ea6d1',
        label: 'Action',
        value: elem => elem.action,
    },
];
exports.ssoContextActionSyntheses = [
    {
        '@type': 'table',
        key: '79097dc3-bd87-4db7-8132-19454d652d20',
        label: 'Actions synthèse',
        value: bilan => bilan.sso_context.excel_action_synthese || [],
        template: 'SSO_CONTEXT_ACTION_SYNTHESE',
    },
];
exports.ssoExamenBilan = [
    {
        '@type': 'dateTime',
        key: 'da57a96e-80ba-4e93-9a5d-41c3b9b5ad58',
        label: 'Créé le',
        gridRow: 1,
        value: examenBilan => {
            return {
                time: examenBilan.created_at,
                date: examenBilan.created_at,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '107ea522-e0ec-4e28-962a-4bb59333dc16',
        label: "Date d'examen SSO",
        gridRow: 1,
        value: examenBilan => {
            return {
                time: examenBilan.examen_sso_time,
                date: examenBilan.examen_sso_date,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: '22280eff-9350-4a3a-8285-a6958ac4d2ba',
        label: 'Date de sortie de dispositif',
        gridRow: 1,
        value: examenBilan => {
            return {
                time: examenBilan.sortie_dispositif_time,
                date: examenBilan.sortie_dispositif_date,
            };
        },
    },
    {
        '@type': 'integer',
        key: '1e09e29c-74a3-47ae-870e-527a9694c44f',
        label: 'FV',
        gridRow: 2,
        value: examenBilan => examenBilan.fv,
    },
    {
        '@type': 'integer',
        key: '29ff4161-a590-47a6-b0b8-0e1d1717514d',
        label: 'SpO² sous O²',
        gridRow: 2,
        unit: '%',
        value: examenBilan => examenBilan.spoo,
    },
    {
        '@type': 'integer',
        key: '8dc71496-2d82-4c30-8581-d25d53f10429',
        labelWithBilan: true,
        label: examenBilan => {
            return `SpCo${examenBilan.spco_precision === 0 ? ' transcutané' : examenBilan.spco_precision === 1 ? ' expiré' : ''}`;
        },
        gridRow: 3,
        unit: '%',
        value: examenBilan => examenBilan.spco,
    },
    {
        '@type': 'tristate',
        key: '26c4e8cf-4887-4efe-a99a-8f5b23accc19',
        label: 'Fumeur',
        gridRow: 3,
        value: examenBilan => examenBilan.fumeur,
    },
    {
        '@type': 'text',
        key: '7a44bd46-cd26-48ca-99f1-7847cd647dac',
        label: 'Pression sanguine gauche',
        gridRow: 4,
        value: examenBilan => examenBilan.blood_pressure_gauche,
    },
    {
        '@type': 'text',
        key: 'c4e419f4-d53c-4d01-9041-cb06ca0c9682',
        label: 'Pression sanguine droite',
        gridRow: 4,
        value: examenBilan => examenBilan.blood_pressure_droite,
    },
    {
        '@type': 'integer',
        key: '22f015a3-a02a-4ce0-bdf1-eba16ad4b5e2',
        label: 'FC',
        gridRow: 4,
        unit: ' bpm',
        value: examenBilan => examenBilan.fc,
    },
    {
        '@type': 'integer',
        key: 'c788b2f1-daaf-411a-a227-e10c0bc6cf2d',
        label: 'Score de Glasgow',
        gridRow: 5,
        value: examenBilan => utils.glasgowScoreValue(examenBilan.glasgow_eyes, examenBilan.glasgow_verbal, examenBilan.glasgow_motricity),
    },
    {
        '@type': 'text',
        key: '6734dfff-17a8-4f00-900e-92dba1d1983b',
        label: 'Glasgow yeux',
        gridRow: 5,
        value: examenBilan => data_1.GLASGOW_Y_SSO_SMP_OPTS.find(opt => opt.value === examenBilan.glasgow_eyes)?.label ?? null,
    },
    {
        '@type': 'text',
        key: '2f087050-e63f-4130-aec4-997018e44469',
        label: 'Glasgow verbal',
        gridRow: 5,
        value: examenBilan => data_1.GLA_V_SSO_SMP_OPTS.find(opt => opt.value === examenBilan.glasgow_verbal)?.label ?? null,
    },
    {
        '@type': 'text',
        key: 'f9e26ff6-f171-4562-ab43-24cddd4deef4',
        label: 'Glasgow motricité',
        gridRow: 5,
        value: examenBilan => data_1.GLASGOW_M_SSO_SMP_OPTS.find(opt => opt.value === examenBilan.glasgow_motricity)?.label ?? null,
    },
    {
        '@type': 'integer',
        key: 'dee6ef1a-c71e-4593-a3d0-584577c26524',
        label: 'Glycémie',
        gridRow: 6,
        value: examenBilan => {
            switch (examenBilan.glycemie) {
                case -2:
                case '-2.0':
                case '-2':
                    return 'LO';
                case -3:
                case '-3.0':
                case '-3':
                    return 'HI';
                default:
                    return examenBilan.glycemie;
            }
        },
        valueUnit: examenBilan => data_1.GLYCEMIE_UNITS.get(examenBilan.glycemie_unit),
    },
    {
        '@type': 'integer',
        key: '58a442b0-830a-421d-ad1a-273a9b573157',
        label: 'Temp.',
        gridRow: 6,
        unit: '°C',
        value: examenBilan => examenBilan.temperature,
    },
    {
        '@type': 'text',
        key: '4ad82030-6794-489d-9821-99aa88584758',
        label: 'Soins apportés',
        gridRow: 6,
        value: examenBilan => examenBilan.soins_apportes,
    },
    {
        '@type': 'tristate',
        key: '65229667-7bca-4cbb-a1eb-72f85658b92c',
        label: 'Contact MAD',
        gridRow: 7,
        value: examenBilan => examenBilan.contact_mad,
    },
    {
        '@type': 'text',
        key: '91099fb4-3ddc-4ff8-883a-a8f0eebf04f8',
        label: 'Décision MAD',
        gridRow: 7,
        value: examenBilan => examenBilan.decision_mad,
    },
    {
        '@type': 'text',
        key: '328b42df-7ed1-4ffa-b142-f39d12047cf3',
        label: 'Commentaire',
        gridRow: 7,
        value: examenBilan => examenBilan.commentaire,
    },
];
// TODO
exports.ssoExamenBilans = [
    {
        '@type': 'array',
        key: '95411746-0526-4cc1-952f-4f8371b08524',
        label: 'Bilans',
        value: examen => examen.bilans,
        template: 'SSO_EXAMEN_BILAN',
    },
];
exports.ssoExamen = [
    {
        '@type': 'link',
        key: 'e00cf4fe-0325-4806-9cca-8ac197ca9ade',
        label: 'Bilan médical Syopé',
        value: examen => {
            if (examen.id_intervention && examen.last_bilan_id) {
                return `/interventions/${examen.id_intervention}/bilans/${examen.last_bilan_id}`;
            }
            else {
                return null;
            }
        },
    },
    {
        '@type': 'text',
        key: '6b18a442-a557-4c52-b6ae-eec683a4014d',
        label: 'Statut',
        value: examen => examen.statut,
    },
    {
        '@type': 'select',
        key: '6f8ba2f9-a34e-4345-a1ab-781b6d8b96ca',
        label: 'Sexe',
        options: data_1.SEX_OPTIONS,
        value: examen => examen.sexe,
    },
    {
        '@type': 'text',
        key: '65d56e58-7a5d-4862-8f31-befe8003942a',
        label: 'Nom',
        value: examen => examen.nom,
    },
    {
        '@type': 'text',
        key: 'db430a5d-e5db-4791-b06d-d10e1760e7a3',
        label: 'Nom de naissance',
        value: examen => examen.nom_de_naissance,
    },
    {
        '@type': 'text',
        key: '4c1521cd-afa7-47b3-bf31-c395e2dd727c',
        label: 'Prénom',
        value: examen => examen.prenom,
    },
    {
        '@type': 'text',
        key: 'a41b4ec0-1150-492f-a4ec-57ea5650a9db',
        label: 'Caserne',
        value: examen => examen.caserne,
    },
    {
        '@type': 'text',
        key: 'cec3bd5a-5ab7-4abf-ae9f-a9a26f108e0e',
        label: 'Matricule',
        value: examen => examen.matricule,
    },
    {
        '@type': 'text',
        key: 'c84d61d8-7c57-4f6b-bf1d-bc3321767e6d',
        label: 'Date de naissance',
        value: examen => examen.date_naissance,
    },
    {
        '@type': 'text',
        key: '90bd6b05-fa35-48ba-8a98-db48befe8d72',
        label: 'Âge',
        value: examen => {
            if (examen.age === '' || examen.age === null)
                return null;
            switch (examen.age_unit) {
                case 1:
                    return `${examen.age} jour${examen.age > 1 ? 's' : ''}`;
                case 2:
                    return `${examen.age} mois`;
                default:
                    return `${examen.age} an${examen.age > 1 ? 's' : ''}`;
            }
        },
    },
];
exports.ssoExamens = [
    {
        '@type': 'array',
        key: '95411746-0526-4cc1-952f-4f8371b08524',
        label: 'Examens SSO',
        value: bilan => bilan.sso_examens,
        template: 'SSO_EXAMEN',
    },
];
exports.smpExamenBilan = [
    {
        '@type': 'dateTime',
        key: '0a949258-a64d-4e63-bd42-87250cfcbdb9',
        label: 'Créé le',
        gridRow: 1,
        value: examenBilan => {
            return {
                time: examenBilan.created_at,
                date: examenBilan.created_at,
            };
        },
    },
    {
        '@type': 'dateTime',
        key: 'a8aafe1c-e2c1-42bc-a8fe-abee6e99d7f5',
        label: "Horaire de l'examen SMP",
        gridRow: 1,
        value: examenBilan => {
            return {
                time: examenBilan.examen_smp_time,
                date: examenBilan.examen_smp_date,
            };
        },
    },
    {
        '@type': 'text',
        key: '7dc7388d-f9f1-4ca2-b299-8c2d28211515',
        label: 'Contexte',
        gridRow: 1,
        value: examenBilan => examenBilan.contexte,
    },
    {
        '@type': 'text',
        key: '4191203a-d807-4c76-9e03-a7787ddf63c1',
        label: 'Anxiété',
        gridRow: 2,
        value: examenBilan => examenBilan.anxiete,
    },
    {
        '@type': 'text',
        key: '4191203a-d807-4c76-9e03-a7787ddf63c1',
        label: 'État thymique',
        gridRow: 2,
        value: examenBilan => examenBilan.etat_thymique,
    },
    {
        '@type': 'text',
        key: '3b62f15b-a9e0-444a-bd5d-d7cd691472a4',
        label: 'Trouble du comportement',
        gridRow: 2,
        value: examenBilan => examenBilan.trouble_comportement,
    },
    {
        '@type': 'text',
        key: '2296467c-362e-4a6e-96b7-a2d1877264c4',
        label: 'Contact relationnel',
        gridRow: 3,
        value: examenBilan => examenBilan.contact_relationnel,
    },
    {
        '@type': 'text',
        key: '26bd9b9e-c837-4e49-854c-de8efaedb39e',
        label: 'Verbalisation',
        gridRow: 3,
        value: examenBilan => examenBilan.verbalisation,
    },
    {
        '@type': 'text',
        key: '838914e8-a2d3-40d4-b517-15a55aecd477',
        label: 'Nature du récit',
        gridRow: 3,
        value: examenBilan => examenBilan.nature_recit,
    },
    {
        '@type': 'integer',
        key: 'a5c6eced-e71e-4c04-a8c6-1500449a296e',
        label: 'BFP',
        gridRow: 4,
        value: examenBilan => {
            if (!examenBilan.trauma || !examenBilan.depression || !examenBilan.epuisement) {
                return undefined;
            }
            else {
                return examenBilan.trauma + examenBilan.depression + examenBilan.epuisement;
            }
        },
    },
    {
        '@type': 'integer',
        key: '6939c2ff-c4f2-451d-8222-94953b5376b6',
        label: 'Trauma',
        gridRow: 4,
        value: examenBilan => examenBilan.trauma,
    },
    {
        '@type': 'integer',
        key: '69a01a5a-a893-4bde-b124-ffd5a4d3a8b7',
        label: 'Dépression',
        gridRow: 4,
        value: examenBilan => examenBilan.depression,
    },
    {
        '@type': 'integer',
        key: 'ac6c12bf-e822-4d03-b72e-373518c8f372',
        label: 'Épuisement',
        gridRow: 4,
        value: examenBilan => examenBilan.epuisement,
    },
];
exports.smpExamenBilans = [
    {
        '@type': 'array',
        key: '6a3494ab-c41d-46a3-aa02-785c410b6696',
        label: 'Examens SMP',
        value: examen => examen.bilans,
        template: 'SMP_EXAMEN_BILAN',
    },
];
exports.smpExamen = [
    {
        '@type': 'link',
        key: 'e126bc6e-182d-438d-9dee-e9cc74f1aadb',
        label: 'Bilan médical Syopé',
        value: examen => {
            if (examen.id_intervention && examen.last_bilan_id) {
                return `/interventions/${examen.id_intervention}/bilans/${examen.last_bilan_id}`;
            }
            else {
                return null;
            }
        },
    },
    {
        '@type': 'text',
        key: '77f1a48a-d6df-49a8-8c03-620d310b365b',
        label: 'Statut',
        value: examen => examen.statut,
    },
    {
        '@type': 'select',
        key: 'f874443b-bebb-4ade-94b3-14d947f37edc',
        label: 'Sexe',
        options: data_1.SEX_OPTIONS,
        value: examen => examen.sexe,
    },
    {
        '@type': 'text',
        key: '47556e0e-69ff-426b-bbcc-317d78866a2d',
        label: 'Nom',
        value: examen => examen.nom,
    },
    {
        '@type': 'text',
        key: '111ae741-961e-404a-9e71-192cfbecac19',
        label: 'Nom de naissance',
        value: examen => examen.nom_de_naissance,
    },
    {
        '@type': 'text',
        key: '30c74661-63c0-4038-92d6-fa02556b8f61',
        label: 'Prénom',
        value: examen => examen.prenom,
    },
    {
        '@type': 'text',
        key: '992b7111-c285-4ebe-85bd-46eea984dc24',
        label: 'Caserne',
        value: examen => examen.caserne,
    },
    {
        '@type': 'text',
        key: '2b91a69a-2a6e-41e3-86c3-713667331ce3',
        label: 'Matricule',
        value: examen => examen.matricule,
    },
    {
        '@type': 'text',
        key: '92880df2-1b01-425f-b985-74d02ef2be01',
        label: 'Date de naissance',
        value: examen => examen.date_naissance,
    },
    {
        '@type': 'text',
        key: '578a6bbc-209c-4fb1-a386-597c2046b34a',
        label: 'Âge',
        value: examen => {
            if (examen.age === '' || examen.age === null)
                return null;
            switch (examen.age_unit) {
                case 1:
                    return `${examen.age} jour${examen.age > 1 ? 's' : ''}`;
                case 2:
                    return `${examen.age} mois`;
                default:
                    return `${examen.age} an${examen.age > 1 ? 's' : ''}`;
            }
        },
    },
    /**
     * TODO()
     * List<SMPExamenBilan> bilans;
     */
];
exports.smpExamens = [
    {
        '@type': 'array',
        key: '691f0ec4-6ea0-42b0-9d6a-d497aa055773',
        label: 'Examens SMP',
        value: bilan => bilan.smp_examens,
        template: 'SMP_EXAMEN',
    },
];
